import BaseValidator from "./Base";

export default class MatchValidator extends BaseValidator {
    private matchValueElement: any;

    constructor(name: string, message: string, matchValueElement: any) {
        super(name, message);
        this.matchValueElement = matchValueElement;
    }

    isNotValid(value: any): boolean {
        const matchFieldValue = (<HTMLInputElement>document.getElementById(this.matchValueElement)).value;
        return value !== matchFieldValue;
    }
}
